import * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as display from '../../../display'

import type { Feature } from '../feature'

/**
 * Shows a user-facing error toast for failed scenario dropdown mutations.
 */
export const showErrorToastOnMutationError = store.effects.create(
  (feature: Feature, toasterFeature: display.toaster.Feature) =>
    rxjs
      .merge(
        feature.actions.submitEdit.error.observe().pipe(
          rxjs.map(action => ({
            action,
            description: 'We could not save the scenario. Please try again.',
          })),
        ),
        feature.actions.submitDelete.error.observe().pipe(
          rxjs.map(action => ({
            action,
            description: 'We could not delete the scenario. Please try again.',
          })),
        ),
        feature.actions.moveToVisibility.error.observe().pipe(
          rxjs.map(action => ({
            action,
            description:
              'We could not move the scenario. Please try again.',
          })),
        ),
      )
      .pipe(
        rxjs.map(({ action, description }) =>
          toasterFeature.actions.show.from(action).create({
            toast: {
              description,
              name: 'Something went wrong',
              style: ents.core.display.Style.Error,
            },
          }),
        ),
      ),
)
